import React from 'react';
import { Mail, Linkedin, Instagram } from 'lucide-react';

const VogueContact = () => {
  return (
    <section className="py-24 bg-black text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl">
          <div className="mb-16">
            <h2 className="text-5xl md:text-6xl font-bold mb-4" style={{ fontFamily: 'Archivo, sans-serif' }}>LET'S WORK TOGETHER</h2>
            <div className="w-24 h-px bg-white mt-4"></div>
          </div>

          <div className="space-y-8">
            <div>
              <p className="text-xs tracking-widest text-gray-400 mb-2" style={{ fontFamily: 'Archivo, sans-serif' }}>EMAIL</p>
              <a href="mailto:iamjcore@gmail.com" className="text-2xl md:text-3xl hover:opacity-60 transition-opacity" style={{ fontFamily: 'Archivo, sans-serif' }}>iamjcore@gmail.com</a>
            </div>

            <div className="flex gap-6 pt-8">
              <a href="https://www.linkedin.com/in/jcore-design" target="_blank" rel="noopener noreferrer" className="hover:opacity-60 transition-opacity"><Linkedin size={24} /></a>
              <a href="https://instagram.com/jcore.design" target="_blank" rel="noopener noreferrer" className="hover:opacity-60 transition-opacity"><Instagram size={24} /></a>
            </div>
          </div>

          <div className="mt-24 pt-12 border-t border-white/20">
            <p className="text-xs tracking-widest text-gray-400" style={{ fontFamily: 'Archivo, sans-serif' }}>© 2026 JANA JANKE. ALL RIGHTS RESERVED.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VogueContact;